import "./LoadingPage.css";
function LoadingPage() {
  return (
    <div className="loading-icon-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        width="40"
        height="40"
        style={{
          shapeRendering: "auto",
          display: "block",
          background: "rgba(255, 255, 255, 0)",
        }}
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g>
          <circle
            strokeDasharray="164.93361431346415 56.97787143782138"
            r="35"
            strokeWidth="17"
            stroke="#CE1126"
            fill="none"
            cy="50"
            cx="50"
          >
            <animateTransform
              keyTimes="0;1"
              values="0 50 50;360 50 50"
              dur="2.272727272727273s"
              repeatCount="indefinite"
              type="rotate"
              attributeName="transform"
            ></animateTransform>
          </circle>
          <g></g>
        </g>
        {/* <!-- [ldio] generated by https://loading.io --> */}
      </svg>
    </div>
  );
}
export default LoadingPage;
